<template>

  <b-row>
    <b-col md="12">
      <b-card no-body :class="{ open: visibleBody }">
        <b-card-header 
          :class="{ collapsed: !visibleBody }" 
          :aria-expanded="visibleBody ? 'true' : 'false'" 
          role="tab"
          data-toggle="collapse" 
          @click="() => visibleBody = !visibleBody"
          style="padding: 1rem; background-color: #0080C9; color: white; font:45px; padding:15px;  ">
          <span class="lead collapse-title">
            <strong>DESCANSO MEDICO</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="padding:1.5rem">

            <b-alert 
              show 
              variant="warning" 
              class="p-2" 
              v-if="descansos30Dias.length"
            >
              <div>
                <i class="fa-solid fa-triangle-exclamation mr-1"/>
                El paciente cuenta con descanso medico en el ultimo mes:
              </div>

              <div class="mt-2" v-if="descansos30Dias.length">
                <div 
                  class="row" 
                  v-for="descanso in descansos30DiasShow" 
                  :key="descanso.id"
                >
                  <h6 class="col-3">Fecha: {{ descanso.fecha }}</h6>
                  <h6 class="col-2">Dias: {{ descanso.dias }}</h6>
                  <h6 class="col">Doctor: {{ descanso.doctor }}</h6>
                </div>
              </div>
            </b-alert>

            <b-card style="border: 1px solid #c9c9c9">

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Días de descanso:</h5>
                <b-form-input class="col-2 ml-1" v-model="descanso.diasDescanso" min="0" />
              </b-row>

              <!-- <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Diagnóstico a usar:</h5>

                <v-select 
                  class="col-5" 
                  placeholder="Seleccione una opcion" 
                  :options="diagnosticoOpts"
                  :reduce="option => option" 
                  label="text" 
                  v-model="descanso.tipoDiagnostico" 
                />
              </b-row> -->

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Aislamiento:</h5>

                <v-select 
                  class="col-5" 
                  placeholder="Seleccione una opcion" 
                  :options="aislamientoOpts"
                  :reduce="option => option" 
                  label="text" 
                  v-model="descanso.tipoAislamiento" 
                />
              </b-row>


              <b-row class="my-1 mt-3 d-flex align-items-center">
                <h5 class="col-4">Actividad laboral:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="Actividad laboral del paciente" 
                  rows="1" 
                  no-resize
                  v-model="descanso.actividadLaboral" id="actividadlab" 
                />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Empresa:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="" 
                  rows="1" 
                  no-resize 
                  v-model="descanso.empresa"
                  id="actividadlab" 
                />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Dirección:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="" 
                  rows="1" no-resize
                  v-model="descanso.direccion" 
                  id="actividadlab" 
                />
              </b-row>

              <b-row class="my-3">
                <h5 class="col-12">Observación/Descanso:</h5>
                <b-form-textarea 
                  class="col mx-1" 
                  placeholder="Coloque las observaciones que deberá seguir" 
                  rows="1"
                  v-model="descanso.observacion" no-resize />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Tipo de contingencia: </h5>
                
                <v-select
                  
                  class="col-6" 
                  id="tipocontingencia" 
                  v-model="descanso.tipoContingencia" 
                  placeholder="Seleccione contingencia"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                  :options="tiposContingencia" 
                  label="text" 
                />
              </b-row>

              <b-row class="my-2 mt-3">
                <b-col class="text-right">
                  <b-button 
                    class="px-3 py-1" 
                    variant="primary" 
                    @click="guardarDescanso"
                  >
                    Guardar
                  </b-button>
                </b-col>
              </b-row>
            </b-card>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>


</template>

<script>
import { addNewOpt, stringDateToGeneralDate } from '@/shared/helpers';
import vSelect from "vue-select";
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import { mapState } from 'vuex';
import { descansoMedicoService } from '../../services';

export default {

  name: "DescansoMedico",

  components: {
    vSelect,
  },

  data() {
    return {

      visibleBody: false,

      descansos30Dias: [],

      descanso: {
        estado: "1",
        diasDescanso: 0,
        tipoDiagnostico: null,
        tipoAislamiento: { text: "Ninguno", value: 1 },
        actividadLaboral: null,
        empresa: null,
        direccion: null,
        observacion: '',
        tipoContingencia: null,
      },

      diagnosticoOpts: [
        { text: "Definitivo", value: 1 },
        { text: "Presuntivo", value: 2 },
      ],

      aislamientoOpts: [
        { text: "Ninguno", value: 1 },
        { text: "Aislamiento", value: 2 },
        { text: "Teletrabajo", value: 3 },
      ],
      tiposContingencia: [],

      // methods
      stringDateToGeneralDate,
    };
  },
  created() {
    this.descanso.tipoContingencia = { text: "Enfermedad General", value: 1 }
    this.fetchTipoContingencia();
    this.loadDataLS();
  },

  methods: {

    loadDataLS(){
      const descanso = JSON.parse(localStorage.getItem("descanso"));
      if(!descanso) return;
      
      console.log('el descanso', descanso[0]);
    },


    async loadHistorialDescansos(){
      const historialDescansos = await descansoMedicoService.getAllByPaciente(this.stIdPaciente);

      if(!historialDescansos) return;

      const fechaLimite = new Date();
      fechaLimite.setDate(fechaLimite.getDate() - 30);

      this.descansos30Dias = historialDescansos.filter(d => {
        const fechaCreacion = new Date(d.fechaCreacion);
        return fechaCreacion >= fechaLimite;
      });

    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    async guardarDescanso() {
      const {
        diasDescanso, tipoDiagnostico, tipoAislamiento,
        actividadLaboral, empresa, tipoContingencia,
        observacion, estado, direccion
      } = this.descanso

      const tipoDiagnosticoValue = tipoDiagnostico
        ? this.descanso.tipoDiagnostico.value.toString()
        : null;

      const tipoAislamientoValue = tipoAislamiento
        ? this.descanso.tipoAislamiento.value.toString()
        : null;

      const newItem = {
        diasdescanso   : parseInt(diasDescanso, 10),
        tipodiagnostico: tipoDiagnosticoValue,
        aislamiento    : tipoAislamientoValue,
        actividadlab   : actividadLaboral,
        empresa        : empresa,
        residenciaId   : this.stResidencia.id,
        direccion      : direccion,
        observacion    : observacion,
        contingencia   : tipoContingencia ? tipoContingencia.text : null,
        estado         : estado,
      };

      const descansoList = [newItem];

      // this.descanso.push(newItem);
      localStorage.removeItem('descanso');
      localStorage.setItem('descanso', JSON.stringify(descansoList));

      await this.$swal.fire({
        icon: 'success',
        text: 'Descanso guardado temporalmente.'
      })
    },


    async fetchTipoContingencia() {
      const query = `
        query MyQuery {
          allTipocontingencia {
            descripcion
            id
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.tiposContingencia = response.data.data.allTipocontingencia.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,

          })
        );
      } catch (error) {
        console.error("Ocurrion un error al traer los tipos de contingencia:", error);
      }
    },
  },


  watch: {

    stResidencia: {
      deep: true,
      handler(newValue) {
        this.descanso.direccion = newValue.callePrincipal
      }
    },


    stIdPaciente: {
      deep: true,
      handler() {
        this.loadHistorialDescansos();
      }
    }
  },




  computed: {
    ...mapState({
      stResidencia: state => state.atencionCita.dataCita?.paciente.persona.residencia,
      stDescanso  : state => state.atencionCita.descanso.descanso[0],
      stIdPaciente : state => state.atencionCita.dataCita?.paciente.id
    }),

    descansos30DiasShow() {

      if(this.descansos30Dias.length){

        return this.descansos30Dias.map(d => {

          const doctor = d.consultacita.cita.doctor.idPersona;

          return {
            fecha  : this.stringDateToGeneralDate(d.fechaCreacion).date,
            dias   : d.diasdescanso,
            doctor : `${doctor.primerApellido} ${doctor.primerNombre}`,
          }
        })
      }

      return [];
    }
    
  },



};
</script>
